import React, { useEffect, useRef, useState, useMemo } from "react";
import * as d3 from "d3";
import COLOR_ORDINAL from "../COLOR_ORDINAL";
import styles from "./styles.module.scss";
import Legend from "../Legend";
import STATISTIC_TYPES, {
    FIND_STATISTIC_TYPE_BY_VALUE,
} from "../STATISTIC_TYPES";
import ChartNote from "../ChartNote";
import formatNumber from "../../utils/formatNumber";

const MOCK_DATA = [
    {
        name: "5萬元~未滿7萬元",
        data: [
            {
                name: "鋼筋混凝土(RC)",
                value: "0.1018",
            },
            {
                name: "磚造、加強磚造",
                value: "0.1661",
            },
            {
                name: "鐵皮屋",
                value: "0.0835",
            },
            {
                name: "木造",
                value: "0.1102",
            },
            {
                name: "鋼構",
                value: "0.0000",
            },
            {
                name: "鋼骨鋼筋混凝土(SRC)",
                value: "0.0000",
            },
            {
                name: "其他",
                value: "0.0000",
            },
        ],
    },
    {
        name: "1萬元~未滿3萬元",
        data: [
            {
                name: "鋼筋混凝土(RC)",
                value: "0.1138",
            },
            {
                name: "磚造、加強磚造",
                value: "0.0175",
            },
            {
                name: "鐵皮屋",
                value: "0.2636",
            },
            {
                name: "木造",
                value: "0.0000",
            },
            {
                name: "鋼構",
                value: "0.0640",
            },
            {
                name: "鋼骨鋼筋混凝土(SRC)",
                value: "0.0000",
            },
            {
                name: "其他",
                value: "0.0000",
            },
        ],
    },
    {
        name: "3萬元~未滿5萬元",
        data: [
            {
                name: "鋼筋混凝土(RC)",
                value: "0.1751",
            },
            {
                name: "磚造、加強磚造",
                value: "0.2222",
            },
            {
                name: "鐵皮屋",
                value: "0.0485",
            },
            {
                name: "木造",
                value: "0.0000",
            },
            {
                name: "鋼構",
                value: "0.0000",
            },
            {
                name: "鋼骨鋼筋混凝土(SRC)",
                value: "0.0000",
            },
            {
                name: "其他",
                value: "0.0000",
            },
        ],
    },
    {
        name: "沒有收入",
        data: [
            {
                name: "鋼筋混凝土(RC)",
                value: "0.0000",
            },
            {
                name: "磚造、加強磚造",
                value: "0.0000",
            },
            {
                name: "鐵皮屋",
                value: "0.0000",
            },
            {
                name: "木造",
                value: "0.0000",
            },
            {
                name: "鋼構",
                value: "0.0000",
            },
            {
                name: "鋼骨鋼筋混凝土(SRC)",
                value: "0.0000",
            },
            {
                name: "其他",
                value: "0.0000",
            },
        ],
    },
    {
        name: "20萬元~未滿25萬元",
        data: [
            {
                name: "鋼筋混凝土(RC)",
                value: "0.2574",
            },
            {
                name: "磚造、加強磚造",
                value: "0.0000",
            },
            {
                name: "鐵皮屋",
                value: "0.0000",
            },
            {
                name: "木造",
                value: "0.0000",
            },
            {
                name: "鋼構",
                value: "0.0000",
            },
            {
                name: "鋼骨鋼筋混凝土(SRC)",
                value: "0.0000",
            },
            {
                name: "其他",
                value: "0.0000",
            },
        ],
    },
    {
        name: "13萬元~未滿15萬元",
        data: [
            {
                name: "鋼筋混凝土(RC)",
                value: "0.2623",
            },
            {
                name: "磚造、加強磚造",
                value: "0.8465",
            },
            {
                name: "鐵皮屋",
                value: "0.0000",
            },
            {
                name: "木造",
                value: "0.0000",
            },
            {
                name: "鋼構",
                value: "0.0000",
            },
            {
                name: "鋼骨鋼筋混凝土(SRC)",
                value: "0.0000",
            },
            {
                name: "其他",
                value: "0.0000",
            },
        ],
    },
    {
        name: "9萬元~未滿11萬元",
        data: [
            {
                name: "鋼筋混凝土(RC)",
                value: "0.3353",
            },
            {
                name: "磚造、加強磚造",
                value: "0.1504",
            },
            {
                name: "鐵皮屋",
                value: "0.0000",
            },
            {
                name: "木造",
                value: "0.0000",
            },
            {
                name: "鋼構",
                value: "0.0000",
            },
            {
                name: "鋼骨鋼筋混凝土(SRC)",
                value: "0.0000",
            },
            {
                name: "其他",
                value: "1.0000",
            },
        ],
    },
    {
        name: "15萬元~未滿20萬元",
        data: [
            {
                name: "鋼筋混凝土(RC)",
                value: "0.2346",
            },
            {
                name: "磚造、加強磚造",
                value: "0.0458",
            },
            {
                name: "鐵皮屋",
                value: "1.0000",
            },
            {
                name: "木造",
                value: "0.0000",
            },
            {
                name: "鋼構",
                value: "0.0000",
            },
            {
                name: "鋼骨鋼筋混凝土(SRC)",
                value: "0.0000",
            },
            {
                name: "其他",
                value: "0.0000",
            },
        ],
    },
    {
        name: "11萬元~未滿13萬元",
        data: [
            {
                name: "鋼筋混凝土(RC)",
                value: "0.3496",
            },
            {
                name: "磚造、加強磚造",
                value: "0.9651",
            },
            {
                name: "鐵皮屋",
                value: "0.0000",
            },
            {
                name: "木造",
                value: "0.0000",
            },
            {
                name: "鋼構",
                value: "0.0000",
            },
            {
                name: "鋼骨鋼筋混凝土(SRC)",
                value: "0.0000",
            },
            {
                name: "其他",
                value: "0.0000",
            },
        ],
    },
    {
        name: "不到1萬元",
        data: [
            {
                name: "鋼筋混凝土(RC)",
                value: "0.0315",
            },
            {
                name: "磚造、加強磚造",
                value: "0.0322",
            },
            {
                name: "鐵皮屋",
                value: "0.0123",
            },
            {
                name: "木造",
                value: "0.1441",
            },
            {
                name: "鋼構",
                value: "0.0000",
            },
            {
                name: "鋼骨鋼筋混凝土(SRC)",
                value: "0.0000",
            },
            {
                name: "其他",
                value: "0.0000",
            },
        ],
    },
    {
        name: "7萬元~未滿9萬元",
        data: [
            {
                name: "鋼筋混凝土(RC)",
                value: "0.1294",
            },
            {
                name: "磚造、加強磚造",
                value: "0.6838",
            },
            {
                name: "鐵皮屋",
                value: "0.0000",
            },
            {
                name: "木造",
                value: "0.6983",
            },
            {
                name: "鋼構",
                value: "0.0000",
            },
            {
                name: "鋼骨鋼筋混凝土(SRC)",
                value: "0.0000",
            },
            {
                name: "其他",
                value: "0.0000",
            },
        ],
    },
    {
        name: "25萬元及以上",
        data: [
            {
                name: "鋼筋混凝土(RC)",
                value: "0.4503",
            },
            {
                name: "磚造、加強磚造",
                value: "0.2961",
            },
            {
                name: "鐵皮屋",
                value: "0.0000",
            },
            {
                name: "木造",
                value: "0.0000",
            },
            {
                name: "鋼構",
                value: "0.0000",
            },
            {
                name: "鋼骨鋼筋混凝土(SRC)",
                value: "0.0000",
            },
            {
                name: "其他",
                value: "0.0000",
            },
        ],
    },
];

const GroupedBarsChart = ({
    data = MOCK_DATA,
    statisticsType = 1,
    chartTitle = "",
    chart2Title = "",
    chart3Title = "",
    chartNote = "",
}) => {
    const svgRef = useRef(null);
    const containerRef = useRef(null);
    const [legends, setLegends] = useState([]);
    const tooltipRef = useRef(null);

    useEffect(() => {
        const margin = { top: 20, right: 100, bottom: 40, left: 240 };
        const BAR_HEIGHT = 20; // 長條高度
        const BAR_PADDING = 10; // 同組長條間距
        const GROUP_PADDING = 40; // 不同組間距
        const BOTTOM_PADDING = 40; // 最後一條長條到 x 軸的距離

        // 每組內的總高度 = 長條高度 * 長條數量 + (長條數量-1) * 長條間距
        const GROUP_HEIGHT =
            BAR_HEIGHT * data[0].data.length +
            (data[0].data.length - 1) * BAR_PADDING;

        // 總高度 = 組高度 * 組數 + (組數-1) * 組間距 + 底部間距
        const height =
            GROUP_HEIGHT * data.length +
            (data.length - 1) * GROUP_PADDING +
            BOTTOM_PADDING;
        const width =
            Math.min(window.innerWidth, 1440) -
            180 -
            180 -
            margin.left -
            margin.right;

        // 清除舊的SVG內容
        d3.select(svgRef.current).selectAll("*").remove();

        const svg = d3
            .select(svgRef.current)
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)
            .append("g")
            .attr("transform", `translate(${margin.left},${margin.top})`);

        // 獲取所有建築類型（子組）
        const subgroups = data[0].data.map((d) => d.name);

        // 獲取所有收入範圍（主組）
        const groups = data.map((d) => d.name);

        // X軸（數值軸）
        const x = d3
            .scaleLinear()
            .domain([
                0,
                statisticsType === STATISTIC_TYPES.百分比.value
                    ? 1
                    : d3.max(data, (d) =>
                          d3.max(d.data, (d) => parseFloat(d.value))
                      ),
            ])
            .range([0, width])
            .nice();

        // Y軸（收入範圍）
        const y = d3.scaleBand().domain(groups).range([0, height]).padding(0);

        // 重新計算 Y 軸的位置
        const yAxis = d3.axisLeft(y);
        yAxis.tickSize(6); // 設置刻度線長度為正值，使其指向外側

        // 顏色比例尺
        const color = d3.scaleOrdinal().domain(subgroups).range(COLOR_ORDINAL);

        // 添加X軸
        svg.append("g")
            .attr("transform", `translate(0,${height})`)
            .call(
                d3
                    .axisBottom(x)
                    .ticks(
                        10,
                        statisticsType === STATISTIC_TYPES.百分比.value
                            ? "%"
                            : undefined
                    )
            );

        // 獲取 x 軸的刻度值
        const xTicks = x.ticks(10).map((d) => d);
        svg.selectAll(".background-stripe")
            .data(xTicks)
            .join("rect")
            .attr("class", "background-stripe")
            .attr("x", (d, i) => x(xTicks[i]))
            .attr("y", 0)
            .attr("width", (d, i) => {
                if (i === xTicks.length - 1) return 0;
                return x(xTicks[i + 1]) - x(xTicks[i]);
            })
            .attr("height", height)
            .attr("fill", (d, i) => (i % 2 === 0 ? "#F9F9F9" : "#fff"))
            .attr("opacity", 0.4)
            .attr("stroke", "#D2D2D2")
            .attr("stroke-width", 1);

        // 繪製分組長條圖
        const groups_g = svg
            .append("g")
            .selectAll("g")
            .data(data)
            .join("g")
            .attr(
                "transform",
                (d, i) => `translate(0,${i * (GROUP_HEIGHT + GROUP_PADDING)})`
            );

        const tooltip = d3.select(tooltipRef.current);

        // D3 bar
        groups_g.each(function (groupData, groupIndex) {
            d3.select(this)
                .selectAll("rect")
                .data(groupData.data)
                .join("rect")
                .attr("x", 0)
                .attr("y", (d, i) => {
                    return i * (BAR_HEIGHT + BAR_PADDING);
                })
                .attr("width", (d) => x(parseFloat(d.value)))
                .attr("height", BAR_HEIGHT)
                .attr("fill", (d) => color(d.name))
                .attr("data-value", (d) => d.value)
                .attr("data-name", (d) => d.name)
                .attr("data-group-name", (d) => groupData.name)
                .on("mouseenter", function (event, d, i) {
                    if (!tooltip) return;
                    const mousePosition = d3.mouse(this);

                    const val = d3.select(this).attr("data-value");
                    const name = d3.select(this).attr("data-name");
                    const groupName = d3.select(this).attr("data-group-name");
                    const parentNode = d3.select(this.parentNode);
                    const parentY = parentNode.attr("transform").split(",")[1].replace(/[^0-9]/g, "");

                    const tooltipContent = chart3Title
                        ? `${chart2Title}：${
                                groupName
                            }\n${chart3Title}：${name}\n${chartTitle}的${
                                FIND_STATISTIC_TYPE_BY_VALUE(
                                    statisticsType
                                ).label
                            }：${
                                statisticsType ===
                                STATISTIC_TYPES.百分比.value
                                    ? `${Math.round(val * 100)}%`
                                    : Math.round(val)
                            }`
                        : `${chartTitle}：${
                                groupName
                            }\n${chart2Title}：${name}\n${chartTitle}的${
                                FIND_STATISTIC_TYPE_BY_VALUE(
                                    statisticsType
                                ).label
                            }：${formatNumber(
                                val,
                                FIND_STATISTIC_TYPE_BY_VALUE(
                                    statisticsType
                                ).value
                            )}`;


                    const yPos =
                        mousePosition[1] + parseInt(parentY);

                    tooltip
                        .html(tooltipContent)
                        .style("opacity", 1)
                        .style(
                            "left",
                            mousePosition[0] + margin.left + 10 + "px"
                        )
                        .style("top", yPos + "px");
                })
                .on("mousemove", function (event, d, i) {
                    const mousePosition = d3.mouse(this);
                    const parentNode = d3.select(this.parentNode);
                    const parentY = parentNode
                        .attr("transform")
                        .split(",")[1]
                        .replace(/[^0-9]/g, "");
                    const yPos =
                        mousePosition[1] + parseInt(parentY);

                    const val = d3
                        .select(this)
                        .attr("data-value");
                    const name = d3
                        .select(this)
                        .attr("data-name");
                    const groupName = d3.select(this).attr("data-group-name");

                    const tooltipContent = chart3Title
                        ? `${chart2Title}：${
                                groupName
                            }\n${chart3Title}：${name}\n${chartTitle}的${
                                FIND_STATISTIC_TYPE_BY_VALUE(
                                    statisticsType
                                ).label
                            }：${
                                statisticsType ===
                                STATISTIC_TYPES.百分比.value
                                    ? `${Math.round(
                                        val * 100
                                    )}%`
                                    : Math.round(val)
                            }`
                        : `${chartTitle}：${
                                groupName
                            }\n${chart2Title}：${name}\n${chartTitle}的${
                                FIND_STATISTIC_TYPE_BY_VALUE(
                                    statisticsType
                                ).label
                            }：${formatNumber(
                                val,
                                FIND_STATISTIC_TYPE_BY_VALUE(
                                    statisticsType
                                ).value
                            )}`;


                    tooltip
                        .html(tooltipContent)
                        .style("opacity", 1)
                        .style(
                            "left",
                            mousePosition[0] + margin.left + 10 + "px"
                        )
                        .style("top", yPos + "px");
                })
                .on("mouseout", function () {
                    if (!tooltip) return;
                    tooltip.style("opacity", 0);
                });
        });

        // 添加數值標籤
        groups_g
            .selectAll("text")
            .data((d) => d.data)
            .join("text")
            .attr("x", (d) => x(parseFloat(d.value)) + 5)
            .attr(
                "y",
                (d, i) => i * (BAR_HEIGHT + BAR_PADDING) + BAR_HEIGHT / 2
            )
            .attr("dy", "0.35em")
            .text((d) => {
                const value = formatNumber(d.value, statisticsType);
                return value;
            })
            .style("font-size", "12px")
            .style("fill", (d) => color(d.name));

        // 添加Y軸（移到最後繪製）
        svg.append("g")
            .call(yAxis)
            .call((g) => {
                // 調整每個刻度的位置
                g.selectAll(".tick").each(function (d, i) {
                    const tick = d3.select(this);
                    const groupStartY = i * (GROUP_HEIGHT + GROUP_PADDING);
                    const groupCenterY = groupStartY + GROUP_HEIGHT / 2;
                    // 移動整個刻度（包括線和文字）到組的中心
                    tick.attr("transform", `translate(0,${groupCenterY})`);
                });
            })
            .selectAll("text")
            .style("text-anchor", "end")
            .style("font-size", "14px")
            .attr("dx", "-10")
            .each(function (d) {
                const text = d3.select(this);
                if (!d) {
                    text.text("");
                    return;
                }
                if (d.includes("~")) {
                    const parts = d.split("~");
                    text.text("")
                        .append("tspan")
                        .text(parts[0] + "~")
                        .attr("x", -10)
                        .attr("dy", 0);
                    text.append("tspan")
                        .text(parts[1])
                        .attr("x", -10)
                        .attr("dy", "1.2em");
                } else if (d.includes("【訪員請紀錄】")) {
                    const parts = d.split("【訪員請紀錄】");
                    text.text("")
                        .append("tspan")
                        .text(parts[0])
                        .attr("x", -10)
                        .attr("dy", 0);
                    text.append("tspan")
                        .text("【訪員請紀錄】" + parts[1])
                        .attr("x", -10)
                        .attr("dy", "1.2em");
                } else if (d.length > 6) {
                    const midpoint = Math.ceil(d.length / 2);
                    const line1 = d.slice(0, midpoint);
                    const line2 = d.slice(midpoint);
                    text.text("");
                    text.append("tspan")
                        .text(line1)
                        .attr("x", -10)
                        .attr("dy", 0);
                    text.append("tspan")
                        .text(line2)
                        .attr("x", -10)
                        .attr("dy", "1.2em");
                }
            });

        setLegends(
            subgroups.map((key) => ({
                name: key,
                color: color(key),
            }))
        );
    }, [data]);


    return (
        <div className={`${styles.groupBarsChartContainer} stack-bars-chart`}>
            <Legend
                title={chart3Title}
                items={legends}
                className={styles.legend}
            />
            <div className={styles.groupBarsChart} ref={containerRef}>
                <div id="tooltip" className={styles.tooltip} ref={tooltipRef}></div>
                <svg ref={svgRef}></svg>
            </div>
            {chartNote && (
                <ChartNote chartNote={chartNote} className={styles.chartNote} />
            )}
        </div>
    );
};

export default GroupedBarsChart;